import { HideLoader, ShowLoader, UserToken, getUserProfile } from "../../utils/helper";
import { Button } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { GetSunLifeTermInsuranceDetailsAsync } from "../../redux/slice/termLifeSlice";
import { useState, useEffect, useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { CryptoJSDecrypt } from "../../utils/encryption";
import Cookies from "js-cookie";
import TermLifeInsurancePolicyPaper from "./termLifeInsurancePolicyPaper";
import EndowmentPlanPolicyPaper from "./EndowmentPlanPolicyPaper";
import { useSearchParams } from "react-router-dom";
import { GetDetailsByRegisterNo } from "../../redux/slice/dofeSlice";
import { text } from "../../utils/constants";
import ForeignEmploymentPolicyPaper from "./ForeignEmploymentPolicyPaper";

export default function PolicyPaper() {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const prod = searchParams.get("prod");
  const id = searchParams.get("id");

  const policyPaperRef = useRef(null);
  const [policyData, setpolicyData] = useState(null);

  useEffect(() => {
    issuePolicy();
  }, []);

  const issuePolicy = async () => {
    ShowLoader();
    await UserToken();
    if (prod === text.dofe) {
      const response = await dispatch(
        GetDetailsByRegisterNo({
          RegisterNo: CryptoJSDecrypt(id),
          TransactionMethod: "Esewa",
          UserName: getUserProfile().MobileNo,
        })
      );
      if (GetDetailsByRegisterNo.fulfilled.match(response)) {
        setpolicyData(response.payload);
        HideLoader();
      }
      return;
    }
    const response = await dispatch(
      GetSunLifeTermInsuranceDetailsAsync({
        RegisterNo: CryptoJSDecrypt(id),
        TransactionMethod: "Esewa",
        UserName: getUserProfile().MobileNo,
      })
    );
    setpolicyData(response.payload);
    HideLoader();
  };

  const viewPolicyPaper = () => {
    if (prod === text.dofe) {
      return <ForeignEmploymentPolicyPaper policyData={policyData} />;
    }
    return policyData.productCode !== "1" ? (
      <TermLifeInsurancePolicyPaper policyData={policyData} />
    ) : (
      <EndowmentPlanPolicyPaper policyData={policyData} />
    );
  };

  const printDocument = () => {
    html2canvas(policyPaperRef.current).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      var imgWidth = 210;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      var doc = new jsPDF("p", "mm");
      var position = 0; // give some top padding to first page

      doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position += heightLeft - imgHeight; // top padding for other pages
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save("policyPaper.pdf");
    });
  };

  return (
    <>
      {policyData && (
        <section className="policy-paper">
          <div className="text-end me-10 mb-2">
            <Button
              color="blue"
              appearance="primary"
              className="btn-primary print-none"
              onClick={() => printDocument()}
              startIcon={<FontAwesomeIcon icon={faFileArrowDown} />}
            >
              Download
            </Button>
          </div>

          <div ref={policyPaperRef}>
            {viewPolicyPaper()}
          </div>
        </section>
      )}
    </>
  );
}
